import { Pickaxe, Car, MessagesSquare, Palette, Cpu, Layers, Box, Gamepad2, Code, Music, Image, Shield, Wrench, Sword, Boxes, Crown, Gem, Tag, Coins, Sparkles } from "lucide-react";

const MAP = { Pickaxe, Car, MessagesSquare, Palette, Cpu, Layers, Box, Gamepad2, Code, Music, Image, Shield, Wrench, Sword, Boxes, Crown, Gem, Tag, Coins, Sparkles };
export const CATEGORY_ICONS = Object.keys(MAP);
export const CategoryIcon = ({ name, className }) => {
  const I = MAP[name] || Box;
  return <I className={className} />;
};
